var _style, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemaleDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#35C4F9;}\n\t.st1{fill:#4F3B30;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#D1D3D4;}\n\t.st4{fill:#FCC68A;}\n\t.st5{fill:#A7A9AC;}\n\t.st6{fill:#F1F2F2;}\n\t.st7{fill:#EFB67D;}\n\t.st8{fill:#182746;}\n\t.st9{fill:#808285;}\n\t.st10{fill:#364D81;}\n\t.st11{fill:#4C72B1;}\n\t.st12{fill:#293F68;}\n\t.st13{fill:#1F3C68;}\n\t.st14{fill:#192A48;}\n\t.st15{fill:#E6E7E8;}\n\t.st16{fill:#58595B;}\n")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_201_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_92_",
    className: "st0",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2732_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2810_",
    className: "st1",
    d: "M69.3,155.1c1.7-0.1,2.7-2.4,3.2-3.5c0.3-0.8,0.5-1.7,0.6-2.7c0.6-6-3.1-19.6-4.8-27.3 c-1.7-7.8-5.9-30.4-3-51.9c2.9-21.5,9.8-49.3,34.6-49c24.8,0.4,35.5,26.7,37.6,58.3c2.1,31.6-10.5,61.8-11,68.2 c-0.1,1.4,0,2.7,0.2,3.8c0.1,0.3,1.2,4.1,3.4,4.2c3.4,0.1,3.8-2.2,3.8-2.2s0.3,4-3.8,4c0,0,0,0,0,0H69.4l0,0c-4.3,0.1-4-4-4-4 S65.9,155.2,69.3,155.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2809_",
    className: "st2",
    d: "M66.4,200h67.4c-0.4-21.4,4.6-79.9,4.6-79.9l-16.3-4.6l-44.8,0.1l-15.9,4.7 C61.3,120.3,66.6,179.6,66.4,200z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2807_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2808_",
    className: "st2",
    d: "M138.9,200h19.3c-0.4-6.4-0.8-11.3-1-12.7c-1.4-9.2-8.4-55.6-12.8-62.2 c-4.4-6.5-9.7-5.5-9.7-5.5v44.5c0,0,2.9,22.5,3.2,25.4C138,191.2,138.4,195,138.9,200z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2805_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2806_",
    className: "st2",
    d: "M61.1,200c0.5-5,0.9-8.8,1.1-10.3c0.3-2.9,4.3-28.3,4.3-28.3l-1-41.7c0,0-5.3-1-9.7,5.5 c-4.4,6.5-11.4,53-12.8,62.2c-0.2,1.4-0.6,6.3-1,12.7H61.1z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2804_",
    className: "st3",
    points: "83.9,120.9 99.9,121.1 115.6,120.9 107.7,181.1 99.7,194.4 93,180.9  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2803_",
    className: "st4",
    d: "M88.4,113.2c1.4-1.3,0.7-9.6,0.7-9.6l10.6,0.6l10.6-0.6c0,0-0.7,8.3,0.7,9.6 c1.4,1.3,2.9,1.6,2.9,1.6s-0.1,6.6-6.6,8.5c-1.7,0.5-3.3,0.9-4.7,1.1c-1.9,0.4-3.9,0.4-5.9,0c-1.5-0.3-3-0.6-4.7-1.1 c-6.5-1.9-6.6-8.5-6.6-8.5S87,114.5,88.4,113.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2802_",
    className: "st5",
    d: "M94.7,127.4c10.9,0.6,16-1.8,17.9-3.2c1.9-1.4,4-5.8,4.3-7.1c0.3-1.4,0.4-2.3,0.4-2.3 h-3.1c0,0.4-0.3,6.6-6.6,8.4c-1.7,0.5-3.3,0.9-4.7,1.1c-1.9,0.4-3.9,0.4-5.9,0c-1.5-0.3-3-0.6-4.7-1.1c-6.3-1.9-6.6-8.1-6.6-8.4 h-3C82.5,114.8,83.8,126.8,94.7,127.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2801_",
    className: "st5",
    d: "M99.9,127.5c0,0,0.7,4.7,5.6,3.7s8.9-8.9,8.9-8.9L99.9,127.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2800_",
    className: "st5",
    d: "M100,127.5c0,0-0.7,4.7-5.6,3.7s-8.9-8.9-8.9-8.9L100,127.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2799_",
    className: "st6",
    points: "84.5,114 77.5,114.5 76.1,120.2 80.3,125.1 77.8,129.5 93,180.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2798_",
    className: "st6",
    points: "114.9,114 121.8,114.9 123.4,120.2 119.1,125.1 121.6,129.5 107.7,181.1  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2797_",
    className: "st4",
    cx: 99.5,
    cy: 70.1,
    rx: 26.2,
    ry: 38.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2776_",
    className: "st7",
    d: "M110.3,106.4c0-0.6,0-0.5,0-0.9c-3.3,2.2-7,3.5-10.9,3.5c-3.6,0-7.1-1.1-10.2-3.1 c0,0.4,0,0.2,0,0.7c3.2,2,6.7,3.2,10.3,3.2C103.5,109.7,107,108.5,110.3,106.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2767_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2775_",
    className: "st1",
    d: "M86.8,46.1c0,0-2.7,8.5-7.2,15c-4.7,6.8-7.6,11.1-7.4,16.2s3,9.4,3,9.4h-6.5 c0,0-2.5-28.2,2.1-39c4.6-10.8,18.3-21.5,18.3-21.5L86.8,46.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2774_",
    className: "st1",
    d: "M118.4,106.2h16.1c1.2-12.2,1.8-24.5,1.3-34.7c-1.1-22.1-12.1-41.5-26-45.3 c-13.9-3.8-20.6,0-20.6,0l-2.4,19.9c0,0,12.9-1.4,19,5.5c6.2,7.1,9.3,14.4,11,27C117.8,85.8,118.2,97,118.4,106.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2773_",
    className: "st1",
    d: "M120.1,102.1c-0.4,7.2-0.7,13.8-1,18.9c-0.5,8.6-5,10.2-5,10.2s12.8,2.9,16.4-10.3 c0.9-3.2,0.7-12.9,1.8-18.9H120.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2772_",
    className: "st1",
    d: "M129.2,96.7c0.1,10.3,0.1,21.4-0.5,25.8c-1.4,10-8.8,11.9-8.8,11.9s7.6,1.4,11.8-7.7 c2.5-5.4,3.9-17.6,4.7-29.5c-1-0.2-2-0.4-3-0.5H129.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2768_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2770_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2771_",
    className: "st1",
    d: "M81.2,120.1c-0.2-3.3-0.4-7.1-0.6-11.4H69.5c0.5,2.6,0.9,8,1.4,9.8 c3.6,13.2,15.3,11.8,15.3,11.8S81.7,128.7,81.2,120.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2769_",
    className: "st1",
    d: "M74,121.3c-0.5-3.3,0.8-10.3,0.8-18l-9.3,0.5c0.9,9.4,2.5,18.1,4.5,22.4 c4.2,9.1,11.8,7.7,11.8,7.7S75.4,131.3,74,121.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2766_",
    className: "st4",
    d: "M75.3,67.6c0,0-4.6-2.8-5.2,4c-0.6,6.7,1.7,10.8,3.1,11.7c1.4,0.9,2.2,0.6,2.2,0.6V67.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2765_",
    x: 93,
    y: 153.1,
    className: "st3",
    width: 14.7,
    height: 46.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    className: "st8",
    d: "M80.4,163.5c0,0-1.7-20,0-32.2c1.7-12.2,8.2-18.7,8.2-18.7s0.2-0.6,0.4-1.5 c0.2-0.9,0.2-2,0.2-2s-9.4,5.8-11.5,22c-2.1,16.2-0.2,32.3-0.2,32.3H80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    className: "st8",
    d: "M120.2,139.2h2.9c0-0.5,0-1.1,0-1.6c-0.2-1.9-0.4-3.7-0.7-5.6 c-2.5-16.1-12.1-23.1-12.1-23.1s0,0.7,0.1,1.6c0.1,1.1,0.4,1.9,0.4,1.9s7.1,7.5,8.9,19.7c0.2,1.7,0.4,3.5,0.5,5.5 C120.3,138.1,120.2,138.7,120.2,139.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    className: "st9",
    d: "M129.8,178.9c0,0,5.4-0.6,6.2-3.5c0.8-2.9,0.8-3.8-0.2-7.8c-1-3.9-3.8-12.4-3.8-12.4 l0.9-0.4c0,0,2.3,6,3.4,10.3c1.1,4.2,1.9,7.6,0.6,10.8c-1.3,3.3-6.1,4-6.3,4c-0.7,0.1-1.1,0-1.1,0L129.8,178.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    className: "st10",
    d: "M128.3,180.6c0,0,2.1,0.5,1.9-1.1c-0.1-1.5-1.1-1.2-1.5-1.1c-0.3,0-0.7,0.2-0.7,0.2 L128.3,180.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    className: "st10",
    d: "M126.5,180.9c0,0,0.7,0.7,1.8,0.2c1.1-0.5,1.1-2.5,0.1-2.9c-1-0.4-1.6-0.1-1.8,0 c-0.2,0.1-0.6,0.6-0.5,1.3C126.1,180.2,126.2,180.7,126.5,180.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "st8",
    d: "M128.9,180.7C128.9,180.7,128.9,180.7,128.9,180.7c0.5-0.6,0.5-1.7,0-2.3c0,0-0.1,0-0.1,0 C129.3,178.9,129.3,180,128.9,180.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    className: "st11",
    d: "M126.4,180.8c0,0,0.7-0.3,0.7-1.2c-0.1-0.7-0.2-0.8-0.4-1.1c-0.1-0.1-0.2-0.2-0.2-0.2 s-0.3,0.5-0.3,1.2C126.2,180.5,126.4,180.8,126.4,180.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st12",
    d: "M126.4,180.8c0,0,0.6-0.4,0.5-1.2c0-0.8-0.6-1.2-0.6-1.2s-0.3,0.3-0.2,1.2 C126.2,180.5,126.4,180.8,126.4,180.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_25_",
    className: "st13",
    cx: 126.6,
    cy: 179.7,
    rx: 0.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_24_",
    className: "st14",
    cx: 126.6,
    cy: 179.7,
    rx: 0.1,
    ry: 0.3
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_22_",
    className: "st8",
    points: "132.1,155.9 133.3,155.4 131.1,150.2 129.7,150.9  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st9",
    d: "M113.6,178.9c0,0-5.4-0.6-6.2-3.5c-0.8-2.9-0.8-3.8,0.2-7.8c1-3.9,3.8-12.4,3.8-12.4 l-0.9-0.4c0,0-2.3,6-3.4,10.3s-1.9,7.6-0.6,10.8s6.1,4,6.3,4c0.7,0.1,1.1,0,1.1,0L113.6,178.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st10",
    d: "M115.2,180.6c0,0-2.1,0.5-1.9-1.1c0.1-1.5,1.1-1.2,1.5-1.1c0.3,0,0.7,0.2,0.7,0.2 L115.2,180.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st10",
    d: "M117,180.9c0,0-0.7,0.7-1.8,0.2c-1.1-0.5-1.1-2.5-0.1-2.9c1-0.4,1.6-0.1,1.8,0 c0.2,0.1,0.6,0.6,0.5,1.3C117.4,180.2,117.2,180.7,117,180.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st8",
    d: "M114.6,180.7C114.6,180.7,114.5,180.7,114.6,180.7c-0.5-0.6-0.5-1.7,0-2.3 c0,0,0.1,0,0.1,0C114.2,178.9,114.1,180,114.6,180.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st11",
    d: "M117,180.8c0,0-0.7-0.3-0.7-1.2c0.1-0.7,0.2-0.8,0.4-1.1c0.1-0.1,0.2-0.2,0.2-0.2 s0.3,0.5,0.3,1.2C117.3,180.5,117,180.8,117,180.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st12",
    d: "M117,180.8c0,0-0.6-0.4-0.5-1.2c0-0.8,0.6-1.2,0.6-1.2s0.3,0.3,0.2,1.2 C117.3,180.5,117,180.8,117,180.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_15_",
    className: "st13",
    cx: 116.9,
    cy: 179.7,
    rx: 0.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_14_",
    className: "st14",
    cx: 116.9,
    cy: 179.7,
    rx: 0.1,
    ry: 0.3
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_12_",
    className: "st8",
    points: "111.3,155.9 110.1,155.4 112.4,150.2 113.7,150.9  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st8",
    d: "M113.5,152.4l-2-1.1c0,0,3-7,9.8-6.9c6.8,0.1,9.1,4.4,9.6,5c0.5,0.6,1,1.7,1,1.7l-1.9,1.3 c0,0-3.3-5.9-8.6-5.5C115.4,147.3,113.5,152.4,113.5,152.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st8",
    d: "M118.2,144.8l7.2,0.1c0,0-2.2-1.2-2.2-2.1s-0.1-5.2-0.1-5.2h-2.8c0,0,0.1,4.3,0,5.1 C120.2,143.5,118.2,144.8,118.2,144.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8_",
    className: "st9",
    cx: 79.2,
    cy: 171,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_7_",
    className: "st15",
    cx: 79.2,
    cy: 171,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6_",
    className: "st9",
    cx: 79.2,
    cy: 171,
    r: 5.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_5_",
    className: "st6",
    cx: 79.2,
    cy: 171,
    r: 4.7
  })), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_3_",
    className: "st16",
    cx: 79.2,
    cy: 171,
    r: 1.4
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_34_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_35_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_36_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_37_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_38_"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleDoc);
export default __webpack_public_path__ + "static/media/female_doc.0ed612e3d0297a67189651fa0d89aae2.svg";
export { ForwardRef as ReactComponent };